import { Component, Input, OnInit } from '@angular/core';
import { JobListingItem } from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-listing-item-text-paint-button',
  templateUrl: './mj-listing-item-text-paint-button.component.html',
  styleUrls: ['./mj-listing-item-text-paint-button.component.scss'],
})
export class MjListingItemTextPaintButtonComponent implements OnInit {
  @Input() listingItem: JobListingItem;

  currentColor: string;
  colorShouldBeShown: boolean;

  availableColors = ['#FFFFFFFF', '#000000FF'];

  constructor() {}

  ngOnInit() {}

  showColorOptions() {
    this.colorShouldBeShown = !this.colorShouldBeShown;
  }

  setColor($event) {
    this.listingItem.font_rgba = $event;
  }

  toggleColor() {
    this.listingItem.font_rgba =
      this.listingItem.font_rgba === this.availableColors[0]
        ? this.availableColors[1]
        : this.availableColors[0];
  }
}
